import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gift, Scissors } from 'lucide-react';
import scissorsIcon from '../../assets/images/scissors.png';

interface NewUserGiftSectionProps {
  serviceType: 'flower' | 'fruit' | 'cat_grass';
  isEligible: boolean;
  subscriptionType: 'monthly' | 'yearly' | 'trial';
  className?: string;
}

const NewUserGiftSection: React.FC<NewUserGiftSectionProps> = ({
  serviceType,
  isEligible,
  subscriptionType,
  className = ''
}) => {
  const { t } = useTranslation();

  // Only show for flower service type, eligible users, and non-trial subscriptions
  if (serviceType !== 'flower' || !isEligible || subscriptionType === 'trial') {
    return null;
  }

  return (
    <div className={`bg-gray-50 rounded-lg p-4 ${className}`}>
      <div className="flex items-center gap-2 text-sm text-green-600 mb-2">
        <Gift size={16} />
        <span>{t('subscription.newUserGift.badge')}</span>
      </div>
      <div className="flex items-center gap-2">
        <img src={scissorsIcon} alt="Flower Scissors" className="w-8 h-8 object-contain" />
        <div>
          <div className="text-sm font-medium">{t('subscription.newUserGift.flowerScissors.title')}</div>
          <div className="text-xs text-gray-500">{t('subscription.newUserGift.flowerScissors.value')}</div>
        </div>
      </div>
    </div>
  );
};

export default NewUserGiftSection; 